import type { MailboxInfo } from "owa-client-types";
import { getIsBitSet, type ListViewBitFlagsMasks } from "owa-bit-flags/lib/utils/listViewBitFlagsUtil";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getScenarioStore from "./getScenarioStore";
import SearchScenarioId from "../store/schema/SearchScenarioId";
import type { SearchScope } from "owa-search-service/lib/data/schema/SearchScope";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";
import canToggleSearchIncludeDeleted from "./canToggleSearchIncludeDeleted";

// Returns whether the search should include deleted items based on the mailbox settings and scope.
export default function getSearchIncludeDeleted(mailboxInfo: MailboxInfo, useOverride: boolean = true, scope?: SearchScope): boolean {
    if (useOverride && isGlobalFeatureEnabled("sea-toggleIncludeDeleted")) {
        if (scope && !canToggleSearchIncludeDeleted(scope, mailboxInfo)) {
            if ("folderId" in scope) {
                const folderName = folderIdToName(scope.folderId, true);
                return folderName === "deleteditems" || folderName === "archivedeleteditems";
            }
            return !getIsBitSet(256, mailboxInfo);
        }
        return (getScenarioStore(SearchScenarioId.Mail).includeDeletedOverride ??
            !getIsBitSet(256, mailboxInfo));
    }
    
    return !getIsBitSet(256, mailboxInfo);
}
